import { observer } from 'mobx-react-lite'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { CommonNumbersWithDesc } from 'pages/settings/pages/compliance/ui/CommonNumbers/CommonNumbersWithDesc'

export const Numbers = observer(() => {
  const tollFreeStepsContext = useTollFreeStepsContext()
  const { numbersNextStepClick } = tollFreeStepsContext

  return (
    <CommonNumbersWithDesc
      store={tollFreeStepsContext}
      nextText='Next'
      nextHandler={numbersNextStepClick}
    />
  )
})
